export default {
  categories: {},
  subcategories: [],
  publishedDates: [],
  documentTypes: [],
  documentSources: [],
  headerSort: {
    name: 'created_at',
    sort: 'desc'
  },
  municipality: {
    id: '',
    name: 'सबै स्थानिय सरकारहरु',
    nameEn: 'All Municipalities',
    hasData: false
  },
  search: '',
  // sort: 'asc',
  page: 1,
  lang: 'np'
};



// WEBPACK FOOTER //
// ./src/filters/initialState.js